var render = function render(){var _vm=this,_c=_vm._self._c;return _c('aside',[_c('Close',{staticClass:"close-button",on:{"click":function($event){return _vm.$emit('close')}}}),_c('strong',[_vm._v(_vm._s(_vm.title))]),_c('p',[_vm._v(_vm._s(_vm.description))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }